<template>
  <e-auto-complete class="auto-input"
                   v-model="text"
                   :values="dynamicItems"
                   @update="dynamicSearchPlace"
                   :read-only="readOnly"
                   @input="inputEvt"
                   :is-char="isChar"
                   :placeholder="plaholder"
                   :is-char-alert="isCharAlert"
                   :list-group-width="listGroupWidth"
                   :disabled="disabled"
                   :auto-focus="autoFocus"
  >
  </e-auto-complete>
</template>

<script>
import { debounce } from 'lodash'
import apiCommons from '@/api/services/commons'
import EAutoComplete from '@/components/common/EAutoComplete'

const SEARCH_DELAY = 250 // 입력이 멈춘 뒤 지명 조회까지 대기(ms)

export default {
  name: 'EAutoCompletePlace',
  components: {
    EAutoComplete
  },
  props: {
    ctrCd: { type: String, default: '', required: false },
    plcCd: { type: String, default: '', required: false },
    readOnly: { type: Boolean, default: false, required: false },
    isChar: { type: Boolean, default: false, required: false },
    plaholder: { type: String, default: '', required: false },
    isCharAlert: { type: Boolean, default: false, required: false },
    listGroupWidth: { type: String, default: '', required: false },
    disabled: { type: Boolean, default: false, required: false },
    autoFocus: { type: Boolean, default: false, required: false }
  },
  data: function () {
    return {
      text: '',
      rtnVo: {
        ctrCd: '',
        ctrEnm: '',
        plcCd: '',
        plcEnm: '',
        plcNm: '',
        plcCatCd: ''
      },
      items: [],
      dynamicItems: [],
      lastKeyword: '',
      placeholder: this.$t('msg.MAIN010G030.035')
    }
  },
  computed: {
    changeData () {
      const { ctrCd, plcCd } = this.$props
      return { ctrCd, plcCd }
    }
  },
  watch: {
    changeData (newVal, oldVal) {
      if (oldVal.ctrCd !== newVal.ctrCd || oldVal.plcCd !== newVal.plcCd) {
        this.initData(newVal.ctrCd, newVal.plcCd)
      }
    }
  },
  created () {
    // 키 입력마다 조회되지 않도록 디바운스. 인스턴스별로 감싸야 출발/도착 칸이 서로의 대기를 취소하지 않는다.
    this.searchPlace = debounce(this.searchPlace, SEARCH_DELAY)

    if (this.ctrCd !== '' && this.plcCd !== '') {
      this.initData(this.$props.ctrCd, this.$props.plcCd)
    }
  },
  beforeDestroy () {
    this.searchPlace.cancel()
  },
  methods: {
    initData (ctrCd, plcCd) {
      if (ctrCd === '' && plcCd === '') {
        this.rtnVo = {
          ctrCd: '',
          ctrEnm: '',
          plcCd: '',
          plcEnm: '',
          plcNm: '',
          plcCatCd: ''
        }
        //this.text = ''
        return
      }

      apiCommons.getCommonsPlacesInfo(ctrCd, plcCd).then((data) => {
        if (data.data !== undefined) {
          this.text = data.data.plcEnm
        } else {
          this.text = ''
        }
      })
    },
    dynamicSearchPlace: function (e) {
      const keyword = e
      if (keyword === '') {
        this.searchPlace.cancel() // 대기 중인 조회 취소
        this.items = []
        this.dynamicItems = []
        return
      }

      this.searchPlace(keyword)
    },
    searchPlace: function (keyword) {
      this.lastKeyword = keyword

      apiCommons.getCommonsPlaces(keyword).then((data) => {
        // 이전 검색어의 응답이 늦게 도착한 경우는 버린다
        if (keyword !== this.lastKeyword) {
          return
        }

        this.items = data.data
        this.dynamicItems = this.items === undefined ? [] : this.items.map(vo => vo.plcEnm)
      })
    },
    inputEvt (val) {
      if (this.items === undefined || this.items === null || this.items.length === 0) {
        this.rtnVo = {
          ctrCd: '',
          ctrEnm: '',
          plcCd: '',
          plcEnm: '',
          plcNm: '',
          plcCatCd: ''
        }
        this.$emit('change', this.rtnVo)
        return
      }
      const tvo = this.items.find(vo => vo.plcEnm === val)

      if (tvo !== undefined) {
        this.rtnVo = {
          ctrCd: tvo.ctrCd,
          ctrEnm: tvo.ctrEnm,
          plcCd: tvo.plcCd,
          plcEnm: tvo.plcEnm,
          plcNm: tvo.plcNm,
          plcCatCd: tvo.plcCatCd
        }
      } else {
        this.rtnVo = {
          ctrCd: '',
          ctrEnm: '',
          plcCd: '',
          plcEnm: '',
          plcNm: '',
          plcCatCd: ''
        }
      }
      this.$emit('change', this.rtnVo)
    }
  }
}
</script>
